import {DuplicatesState} from "@/store/settings/duplicates/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/settings/duplicates/getters";
import {mutations} from "@/store/settings/duplicates/mutations";
import {actions} from "@/store/settings/duplicates/actions";

export const state: DuplicatesState = {
  duplicates:[],
}

export const duplicates: Module<DuplicatesState, RootState> = {
  state,
  getters,
  mutations,
  actions
}